import moment from 'moment';
import randomString from 'random-string';

/**
 * Create a function which will call the callback function
 * after the given amount of milliseconds has passed since
 * the last time the callback function was called.
 */
export const idle = (callback, delay) =>
{
	let handle;

	return () =>
	{
		if (handle)
		{
			clearTimeout(handle);
		}

		handle = setTimeout(callback, delay);
	};
};

export const isContainDigitsInString = (text) =>
{
	const matchPattern =text.match(/\d+/g);

	return matchPattern != null;
};

export const isContainUpper =(text) =>
{
	return text.toLowerCase() !== text;
};

export const isContainSpecialChar = (text) =>
{
	// eslint-disable-next-line no-useless-escape
	const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

	return format.test(text);
};

export const getElementWidth = (ref) =>
{
	return ref.current ? ref.current.offsetWidth : 0;
};

/**
 * Error produced when a socket request has a timeout.
 */
export class SocketTimeoutError extends Error
{
	constructor(message)
	{
		super(message);

		this.name = 'SocketTimeoutError';

		if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
			Error.captureStackTrace(this, SocketTimeoutError);
		else
			this.stack = (new Error(message)).stack;
	}
}

export const getRandomInt = (max) => (Math.floor(Math.random() * max));

export const validateEmail = (email) =>
{
	return String(email)
		.toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
};

export const getNameAvatar = (name) =>
{
	const names = name.split(' ');

	if (names.length > 1)
	{
		return `${names[0].charAt(0)}${names[names.length-1].charAt(0)}`;
	}

	return names[0].substring(0, 2);
};

export function copyToClipboard(text)
{
	navigator.clipboard.writeText(text);
}

export function generateMeetingRoomId()
{
	const min = 1000000000;
	const max = 9000000000;
	const num = Math.floor(Math.random() * min) + max;

	const meetingRoomId = num.toString();

	return `${meetingRoomId.substring(0, 3)}-${meetingRoomId.substring(3, 6)}-${meetingRoomId.substring(6)}`;
}

export function json2array(json)
{
	const result = [];
	const keys = Object.keys(json);

	keys.forEach(function(key)
	{
		result.push(json[key]);
	});

	return result;
}

export const fileTypes = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'];

export function validImageFileType(file)
{
	return fileTypes.includes(file.type);
}

export const validationPassword = (password, type) =>
{
	if (password.length < 8 && (type === 'length' || !type))
	{
		return false;
	}
	else if (!isContainDigitsInString(password) && (type === 'digit' || !type))
	{
		return false;
	}
	else if (!isContainUpper(password) && (type === 'upper' || !type))
	{
		return false;
	}
	else if (!isContainSpecialChar(password) && (type === 'symbol' || !type))
	{
		return false;
	}
	else
	{
		return true;
	}
};

export function getFileExtension(filename)
{
	const parts = filename.split('.');

	if (parts.length === 1)
	{
		return null; // No file extension found
	}

	return parts.pop().toLowerCase();
}

export function getTimeLimit(limit, type)
{
	const duration = moment.duration(limit, type);
	const hours = Math.floor(duration.asHours());
	const minutes = Math.floor(duration.asMinutes()) % 60;

	let formattedTime = '';

	if (hours > 0)
	{
		if (minutes === 0)
		{
			formattedTime = `${hours} hrs`;
		}
		else
		{
			formattedTime = `${hours} hrs ${minutes.toString().padStart(2, '0')} mins`;
		}
	}
	else
	{
		formattedTime = `${minutes} mins`;
	}

	return formattedTime;
}

export function checkPrivateRoom(pathname)
{
	const pathArray = pathname.split('/');
	const lastPath = pathArray[pathArray.length - 1];

	return lastPath === 'private';
}

export function convertTo24Hours(time, isHalfHour)
{
	if (!isHalfHour)
	{
		return moment(time).format('MMM DD hh:mm A');
	}
	else
	{
		return moment(time).format('MMM DD HH:mm');
	}
}

export function generateChatIndex(roomShortId, senderId, receiverId)
{
	if (senderId && receiverId)
	{
		return `${roomShortId}-${senderId > receiverId ? receiverId : senderId}:${senderId > receiverId ? senderId : receiverId}`;
	}
	else
	{
		return roomShortId;
	}
}

export function isMobile()
{
	return /Mobi|Android/i.test(navigator.userAgent);
}

export function isTablet()
{
	return /iPad|Tablet/i.test(navigator.userAgent) ||
         (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document);
}

export function generatePeerId(userId)
{
	const randomPart = randomString(8).toLowerCase();

	return `${randomPart}-${userId}`;
}
